import React, { Component } from 'react';

import Player from '../services/player.js'

import '../../css/StationButton.css';

class StationButton extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      element: props.element,
      elements: props.elements,
      type: props.type
    }
  }


  componentWillReceiveProps(newProps) {
    this.state = {
      element: newProps.element,
      elements: newProps.elements,
      type: newProps.type
    }
  }

  playElements(evt) {

    evt.stopPropagation();
    evt.preventDefault();

    let elements = this.state.elements;

    if (!elements)
      elements = [this.state.element];

    Player.searchTracks({type: this.state.type, terms: elements });
  }

  render() {

    return (
      <span className="stationButton">
        <i title="Play station" onClick={this.playElements.bind(this)} className="fontastic icon-radio-waves clickable"></i>
      </span>
    );
  }

}

export default StationButton;



// WEBPACK FOOTER //
// ./src/js/components/StationButton.jsx